// extracted by mini-css-extract-plugin
export default {"content":"SimpleContent_content__M2WcY"};